// packages/console/src/components/panels/ProbeGraphGate.tsx
//
// The render-site gate for the admin-only probe graph. It centralizes the
// "who may see it" rule (admin OR owner, with a job selected) so FileTranscoder
// stays declarative and the condition lives in one place. A non-admin, an
// absent role, or no selection renders nothing, so the panel never mounts and
// never fires an admin-only fetch. This mirrors how isOwner gates the
// OutputProfilePanel admin surface.

import { ProbeGraphPanel } from "./ProbeGraphPanel";
import { isAdminRole } from "../../lib/roles";

export function ProbeGraphGate({
  role,
  jobId,
  filename,
}: {
  role: string | undefined;
  jobId: string | null;
  filename?: string;
}) {
  if (!isAdminRole(role) || !jobId) return null;
  return <ProbeGraphPanel jobId={jobId} filename={filename} />;
}
